export const HighlightedIconGold = (props) => (
  <svg
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 120 120"
    {...props}
  >
    <defs>
      <style>
        {
          ".st0 { fill: #d89819;} .st1 { fill: #fff;}"
        }
      </style>
    </defs>
    <path
      className="st0"
      d="M64.09,4.51l8.55,1.43c20.41,4.69,36.76,21.37,41.05,41.87l1.26,8.16v6.47l-.93,6.52c-11.24,57.93-92.92,59.92-106.96,2.59l-1.43-8.55c.13-2.48-.17-5.13,0-7.59C7.53,28.63,29.63,6.41,56.5,4.51c0,0,7.59,0,7.59,0Z"
    />
    <path
      className="st1"
      d="M64.65,32.93l3.65,11.24c.62,1.89,2.38,3.18,4.37,3.18h11.82c4.45,0,6.31,5.7,2.7,8.32l-9.56,6.95c-1.61,1.17-2.29,3.25-1.67,5.14l3.65,11.24c1.38,4.24-3.47,7.76-7.08,5.14l-9.56-6.95c-1.61-1.17-3.79-1.17-5.41,0l-9.56,6.95c-3.6,2.62-8.45-.9-7.08-5.14l3.65-11.24c.62-1.89-.06-3.97-1.67-5.14l-9.56-6.95c-3.6-2.62-1.75-8.32,2.7-8.32h11.82c1.99,0,3.76-1.28,4.37-3.18l3.65-11.24c1.38-4.24,7.37-4.24,8.75,0h.02Z"
    />
  </svg>
)